<template>
  <v-container fluid>
    <v-dialog
        v-model="editDialog"
        max-width="700px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ isEditing ? 'Редактирование данных' : 'Добавление'}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.username" label="Номер телефона"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.name" label="Имя"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.surname" label="Фамилия"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.patronymic" label="Отчество"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.password" type="password" label="Пароль"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select v-model="editedItem.role" :items="roles" label="Роль" item-text="name" item-value="value" />
              </v-col>


            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="close"
          >
            Отмена
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="save"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Панель фильтров -->
    <v-card class="mb-4">
      <v-card-title>
        Пользователи
      </v-card-title>
    </v-card>
    <v-card class="mt-6">
      <v-data-table
          :headers="headers"
          :items="data"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': 'Строк на странице:',
            'items-per-page-options': [5, 10, 20, 50]
          }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col>
                <v-btn
                    @click="addJob"
                    depressed
                    color="primary"
                >
                  <v-icon
                      left
                      dark
                  >
                    mdi-plus
                  </v-icon>
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
              class="mr-2"
              @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: 'AdminUsers',
  data() {
    return {
      roles: [
        { value: "ROLE_ADMIN", name: "Админ" },
        { value: "ROLE_PARTNER", name: "Партнер" },
        { value: "ROLE_USER", name: "Пользователь" },
      ],
      editedItem: {
        username: '+7',
        name: '',
        surname: '',
        patronymic: '',
        password: '',
        email: '',
        role: 'ROLE_USER',
      },
      editDialog: false,
      data: [],
      size: 10,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'ФИО', value: 'fullName' },
        { text: 'Логин', value: 'username' },
        { text: 'Город', value: 'city.name' },
        { text: 'Почта', value: 'email' },
        { text: 'Действия', value: 'actions' },
      ],
      totalElements: 0,
      options: {},
      jobs: [],
      categories: [],
      isEditing: false,
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData () {
      try {
        const data = await this.$store.dispatch('adminController/getAllUsers')
        this.data = data.map((item) => {
          item.fullName = item.name + ' ' + item.surname
          return item
        })
      } catch (e) {
        console.log(e)
      }
    },
    addJob() {
      this.editDialog = true
    },
    close () {
      this.isEditing = false
      this.editDialog = false
      this.editedItem = {
        username: '+7',
        name: '',
        surname: '',
        patronymic: '',
        password: '',
        email: '',
        role: 'ROLE_USER',
      }
    },
    async save () {
      console.log(this.editedItem)
      if (this.isEditing) {
        try {
          this.editedItem.username = this.editedItem.username.slice(1)
          await this.$store.dispatch('adminController/updateUser', this.editedItem)
          showSnackbar({
            message: "Успешно обновлено!",
            color: "success",
            timeout: 3000,
          })
          this.getData()
        } catch (e) {
          showSnackbar({
            message: "Не удалось обновить",
            color: "error",
            timeout: 3000,
          })
        }
      } else {
        try {
          this.editedItem.username = this.editedItem.username.slice(1)
          await this.$store.dispatch('adminController/createUser', this.editedItem)
          showSnackbar({
            message: "Успешно добавлено!",
            color: "success",
            timeout: 3000,
          })
          this.getData()
        } catch (e) {
          showSnackbar({
            message: "Не удалось добавить",
            color: "error",
            timeout: 3000,
          })
        }
      }
      this.isEditing = false
      this.editDialog = false
      this.editedItem = {
        username: '+7',
        name: '',
        surname: '',
        patronymic: '',
        password: '',
        email: '',
        role: 'ROLE_USER',
      }
    },
    async deleteItem (item) {
      try {
        if (confirm('Вы точно хотите удалить данные?')) {
          await this.$store.dispatch('partnerJobs/deleteJob', item.id)
          this.getData()
          showSnackbar({
            message: "Успешно удалено!",
            color: "success",
            timeout: 3000,
          })
        }
      } catch (e) {
        showSnackbar({
          message: "Не удалось удалить",
          color: "error",
          timeout: 3000,
        })
      }
    },
    editItem (item) {
      this.isEditing = true
      this.editedItem = Object.assign({}, item)
      this.editedItem.role = item.role.id
      this.editDialog = true
    },

  }
}
</script>
<style scoped>

</style>